import React from "react";
import "./table.css";

/**
 * // Function to add spaces before capital letters in a string
 * @param {*} header
 * @returns
 */
const formatHeader = (header) => {
  if (typeof header === "string") {
    return header.replace(/([A-Z])/g, " $1").trim();
  }
};

export const Table = ({ tableData, onRowClick, selectedColumns }) => {
  if (!tableData || tableData.length === 0) {
    return <p></p>;
  }

  // Define the desired order of columns
  const columnOrder = [
    "title",
    "country",
    "pilotArea",
    "typeOfRisk",
    "monitoringMethod",
    "mitigationMeasure",
    "period",
    "siteContext",
    "typeOfMonument",
    "naturalEnvironment",
    "filename",
    "references",
    "url",
    //"id",
  ];

  const headers = columnOrder.filter((header) =>
    Object.keys(tableData[0].features[0].properties).includes(header)
  );

  return (
    <div>
      <table>
        <thead>
          <tr>
            {selectedColumns.map((header, index) => (
              <th key={index}>{formatHeader(header)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, rowIndex) => (
            <tr key={rowIndex}>
              {selectedColumns.map((header, colIndex) => {
                // Define a function to modify the URL if needed
                const modifyURL = (url) => {
                  if (url) {
                    if (url.startsWith("DOI:")) {
                      return "https://doi.org/" + url.substring(5);
                    } else if (!url.startsWith("https://")) {
                      return "https://doi.org/" + url;
                    }
                  }
                  return url;
                };

                const modifiedUrl = modifyURL(
                  item.features[0].properties[header]
                );

                return (
                  <td key={colIndex} onClick={() => onRowClick([item])}>
                    <div className="td-wrapper">
                      {header === "url" ? (
                        <a
                          href={modifiedUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.features[0].properties[header]}
                        </a>
                      ) : (
                        item.features[0].properties[header]
                      )}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
